import {
  RevenueCatPurchaseErrorCategory,
  normalizeRevenueCatPurchaseError,
} from "./purchase-errors";

function getErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.toLowerCase() : String(error || "").toLowerCase();
}

export function getPaywallLoadErrorMessage(): string {
  return "We couldn't load the plans. Check your internet connection and try again.";
}

export function getPurchaseErrorMessage(
  error: unknown,
  category?: RevenueCatPurchaseErrorCategory
): string {
  const normalizedCategory = category ?? normalizeRevenueCatPurchaseError(error).category;

  if (normalizedCategory === "user_cancelled") {
    return "Your purchase was cancelled. You have not been charged.";
  }

  if (normalizedCategory === "network") {
    return "The connection was interrupted before we could confirm your purchase. Check your purchase status before trying again.";
  }

  if (
    normalizedCategory === "payment_pending" ||
    normalizedCategory === "store_problem" ||
    normalizedCategory === "operation_in_progress" ||
    normalizedCategory === "already_purchased"
  ) {
    return "Your payment may still be processing. Check your purchase status before trying again.";
  }

  if (normalizedCategory === "invalid_email") {
    return "RevenueCat could not use this account email. Reload the page or contact support.";
  }

  if (normalizedCategory === "configuration" || normalizedCategory === "product_unavailable") {
    return "This plan is not available right now. Reload the plans or contact support.";
  }

  if (normalizedCategory === "payment_rejected") {
    return "Your payment was not accepted. Check your payment details or try another payment method.";
  }

  const message = getErrorMessage(error);
  if (
    message.includes("declined") ||
    message.includes("payment method") ||
    message.includes("card")
  ) {
    return "Your payment was not accepted. Check your payment details or try another payment method.";
  }

  if (
    message.includes("network") ||
    message.includes("failed to fetch") ||
    message.includes("load failed")
  ) {
    return "The connection was interrupted before we could confirm your purchase. Check your internet connection and try again.";
  }

  return "We couldn't confirm your purchase. If you completed payment, wait a moment and check your subscription before trying again.";
}
